import React from "react";
import { StyleSheet, View } from "react-native";
import { useCollection, useDatastore } from "util/datastore";
import { useConfig } from "util/features";
import { PadBox } from "component/basics";
import { Catcher, CatchList } from "system/catcher";
import { colorTeaserBackground } from "component/color";
import { boostComments, Comment, commentTable } from "component/comment";
import { ModeratedComment } from "feature/moderation/ai-premoderator";
import { RichText } from "component/richtext";
import { Banner } from "component/banner";
import { upvoteTable } from "util/stdconfig";
import { TopicConfig } from "structure/topic";
import { nullS } from "util/stdtypes";

// FIXME: This function is too large and should be broken up
/* eslint-disable-next-line max-lines-per-function */
export function REPLACE_CBC_PopularComments({
    about = nullS,
    showInput = true,
    canPost = true,
}) {
    const datastore = useDatastore();
    const {
        noCommentsMessage,
        commentsTopLeftWidgets,
        commentsTopRightWidgets,
        commentBooster,
        popularCommentsLimit,
    } = useConfig<TopicConfig>();
    const comments = useCollection(commentTable, {
        filter: { about, replyTo: null, deleted: null },
        sortBy: 'time',
        reverse: true,
    }) as ModeratedComment[];
    const upVotes = useCollection(upvoteTable);
    const nonViolatingComments = comments.filter(comment => !comment.violates);
    
    const topComments = nonViolatingComments.filter(comment =>
        upVotes.some(upVote => upVote.comment === comment.key)
    );
    topComments.sort((a, b) => {
        const aUpVotes = upVotes.filter(upVote => upVote.comment === a.key).length;
        const bUpVotes = upVotes.filter(upVote => upVote.comment === b.key).length;
        return bUpVotes - aUpVotes;
    });
    const otherComments = nonViolatingComments.filter(comment =>
        !upVotes.some(upVote => upVote.comment === comment.key)
    );
    const rankedComments = [...topComments, ...otherComments];
    const boostedComments = boostComments({comments, rankedComments, datastore, commentBooster});
    
    const s = BasicCommentsStyles;
    return (
        <View>
            <PadBox vert={16}>
                <View style={s.container}>
                    <View style={s.leftContainer}>
                        {commentsTopLeftWidgets?.map((Widget, i) => (
                            <Catcher key={i}>{React.createElement(Widget as any, { comments })}</Catcher>
                        ))}
                    </View>
                    <View style={s.rightContainer}>
                        {commentsTopRightWidgets?.map((Widget, i) => (
                            <Catcher key={i}>{React.createElement(Widget as any, { comments })}</Catcher>
                        ))}
                    </View>
                </View>
            </PadBox>
            {comments?.length == 0 &&
                <PadBox vert={20} horiz={20}><Banner color={colorTeaserBackground}><RichText label={noCommentsMessage} /></Banner></PadBox>
            }
            <CatchList items={boostedComments.slice(0, popularCommentsLimit)} renderItem={comment => <Comment commentKey={comment.key} />} />
        </View>
    )
}


const BasicCommentsStyles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
    },
    leftContainer: {
        flex: 1,
        alignItems: 'flex-start',
    },
    rightContainer: {
        flex: 1,
        alignItems: 'flex-end',
    },
});
